module.exports = __webpack_public_path__ + "img/glide-g.8058309b.svg";